import React, { useState, useEffect } from "react";
import {
  Button,
  Flex,
  Input,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Skeleton,
  MenuOptionGroup,
  HStack,
} from "@chakra-ui/react";
import { EllipsisVertical, Rocket } from "lucide-react";
import FundTable from "../components/funds/FundTable";
import { useAppContext } from "../contexts/AppContext";
import TableFilters from "../components/general/TableFilters";

const Funds = ({ onOpen }) => {
  const { data, toggleTableSize, tableSize } = useAppContext();
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  

  // Handle search input
  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };


  // Filter funds on search/filter/strategy change
  useEffect(() => {
    if (data.length === 0) return;

    const filtered = data.filter((fund) => {
      const fundNameMatch = fund.fundName?.toLowerCase().includes(searchQuery);
      const parentFundMatch = fund.parentFund?.toLowerCase().includes(searchQuery);
      const matchesSearch = fundNameMatch || parentFundMatch;

      const matchesNavFrequency =
        !filters.navFrequency || filters.navFrequency.length === 0 ||
        filters.navFrequency.includes(fund.navFrequency);

      const matchesCurrency =
        !filters.fundCurrency || filters.fundCurrency.length === 0 ||
        filters.fundCurrency.includes(fund.fundCurrency.ISO);

      const matchesInvestmentStrategy =
        !filters.investmentStrategy || filters.investmentStrategy.length === 0 ||
        filters.investmentStrategy.includes(fund.investmentStrategy.name);

      return (
        matchesSearch &&
        matchesNavFrequency &&
        matchesCurrency &&
        matchesInvestmentStrategy
      );
    });

    setFilteredData(filtered);
    setIsLoading(false);
  }, [data, searchQuery, filters ]);

  const labelMap = {
    navFrequency: "NAV Frequency",
    investmentStrategy: "Strategy",
    fundCurrency: "Currency",
  };
  const filterOptions = {
    navFrequency: ["Monthly", "Quarterly", "Annually"],
    investmentStrategy: ["Real Estate", "Debt", "Private Equity", "Feeder", "Venture Capital", "Multi"],
    fundCurrency: ["USD", "EUR", "GBP", "JPY", "CHF"],
  };

  return (
    <Flex direction="column" p={0} w={"100%"} gap={8}>
      <Flex justifyContent="space-between" direction={{ lg: "row", base: "column" }} gap={4}>
        <h1>Funds</h1>
        <Button w={"fit-content"} leftIcon={<Rocket size={16} />} onClick={() => onOpen("onboardingProcess")}>
          Start onboarding
        </Button>
      </Flex>

      <Flex gap={2} flex={1} justifyContent="space-between">
        <HStack>
          <Input
            placeholder="Search by fund name..."
            value={searchQuery}
            onChange={handleSearch}
            flex={1}
            w={"260px"}
          />
          <TableFilters
            filters={filters}
            setFilters={setFilters}
            filterOptions={filterOptions}
            labelMap={labelMap}
          />
        </HStack>

        <Menu>
          <MenuButton
            as={IconButton}
            icon={<EllipsisVertical size={20} />}
            variant="outline"
          />
          <MenuList>
            <MenuOptionGroup defaultValue="asc" title="Actions" type="radio">
              <MenuItem onClick={() => alert("Export as CSV clicked")}>
                Export as CSV
              </MenuItem>
              <MenuItem onClick={() => alert("Export as PDF clicked")}>
                Export as PDF
              </MenuItem>
              <MenuItem onClick={() => alert("Generate Report clicked")}>
                Generate report
              </MenuItem>
            </MenuOptionGroup>
            <MenuOptionGroup defaultValue="asc" title="Display" type="radio">
              <MenuItem onClick={toggleTableSize}>
                {tableSize === "sm" ? "Expand view" : "Compact view"}
              </MenuItem>
            </MenuOptionGroup>
          </MenuList>
        </Menu>
      </Flex>

    

      {/* TABLE OR LOADING */}
      {isLoading ? (
        <Flex justifyContent="center" alignItems="center" w={"100%"} flex={1} direction={"column"} gap={4}>
          {[...Array(10)].map((_, i) => (
            <Skeleton key={i} minHeight="42px" w="100%" borderRadius={8} />
          ))}
        </Flex>
      ) : (
        <FundTable data={filteredData} />
      )}
    </Flex>
  );
};

export default Funds;
